import { render, staticRenderFns } from "./VuesticProfileCard.vue?vue&type=template&id=0928661b"
import script from "./VuesticProfileCard.vue?vue&type=script&lang=js"
export * from "./VuesticProfileCard.vue?vue&type=script&lang=js"
import style0 from "./VuesticProfileCard.vue?vue&type=style&index=0&id=0928661b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-profile-card/VuesticProfileCard.vue
// module id = 9NsT
// module chunks = 41